import React from 'react'
import { useSelector } from 'react-redux'
import { userSelectors } from '../../redux/userSlice'
import { UserTypes } from '../../util/constants'
import { Redirect, Route } from 'react-router'

const BeneficiaryRoute = ({ path, component, ...props }) => {
    const isLoggedIn = useSelector(userSelectors.isLoggedIn)
    const userType = useSelector(userSelectors.userType)

    if (isLoggedIn && userType === UserTypes.Beneficiary) {
        return <Route path={path} component={component} {...props} />
    }

    return <Redirect to={isLoggedIn ? '/app/dashboard' : '/'} />
}

export default BeneficiaryRoute
